(() => {
 const root = document.getElementById('CopiPetCart');
 if (!root) return;
 let busy = false;
 const error = document.getElementById('CopiPetCartError');
 async function update(input, quantity) {
   if (busy) return;
   const old = Number(input.value);
   quantity = Math.max(0, Math.floor(Number(quantity)));
   if (!Number.isFinite(quantity) || quantity === old) return;
   busy = true; error.hidden = true;
   root.classList.add('cp-updating');
   try {
     const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/change.js', {
       method: 'POST', headers: {'Content-Type':'application/json', 'Accept':'application/json'},
       body: JSON.stringify({id: input.dataset.key, quantity})
     });
     const result = await response.json();
     if (!response.ok) throw new Error(result.description || result.message || 'No se pudo actualizar la cantidad.');
     // Reload to refresh line discounts, totals, stock messages and the cart badge consistently.
     window.location.reload();
   } catch (e) {
     input.value = old;
     error.textContent = e.message || 'No se pudo actualizar el carrito.';
     error.hidden = false;
     root.classList.remove('cp-updating'); busy = false;
   }
 }
 root.addEventListener('click', e => {
   const btn = e.target.closest('[data-step], [data-remove]');
   if (!btn || busy) return;
   const input = btn.closest('.cp-cart-item')?.querySelector('input[data-key]');
   if (!input) return;
   update(input, btn.hasAttribute('data-remove') ? 0 : Number(input.value) + Number(btn.dataset.step));
 });
 root.addEventListener('change', e => {
   if (e.target.matches('input[data-key]')) update(e.target, e.target.value);
 });
})();
